import { ERROR_CODES } from '@/consts';

export default class CannotBeAFutureDate extends Error {
  static code = ERROR_CODES.CASH_LOG_CANNOT_BE_A_FUTURE_DATE;

  constructor(message) {
    super(message || 'Invalid Date.');
    this.code = ERROR_CODES.CASH_LOG_CANNOT_BE_A_FUTURE_DATE;
  }
}
